import { Progress } from "@-/dev.improve.haniverse.components.ui.progress";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { View } from "@-/com.npmjs.react-native";
import plurCount from "@-/com.npmjs.plur-count";

/**
 * Shared header-expansion progress strip for the Browse dataset pages (primitives, characters,
 * words): a thin bar plus a "{learned} of {total} {noun} learned" caption, where {@link noun}
 * is pluralized against {@link totalCount} via `plur-count`.
 */
export function BrowseLearnedProgress({
  learnedCount,
  noun,
  totalCount,
}: {
  learnedCount: number;
  noun: string;
  totalCount: number;
}) {
  const progressPercent = totalCount === 0 ? 0 : (learnedCount / totalCount) * 100;

  return (
    <View className="w-full px-3 pt-0.5 pb-1">
      <Progress
        className="h-1.5 rounded-full bg-muted"
        indicatorClassName="rounded-full bg-foreground/70"
        value={progressPercent}
      />
      <Text className="mt-1 text-center font-sans text-[11px] text-muted-foreground">
        {learnedCount.toLocaleString()} of {plurCount(totalCount, noun)} learned
      </Text>
    </View>
  );
}
